import { render } from "./FirstLoginModal.vue?vue&type=template&id=6b5fec9c"
import script from "./FirstLoginModal.vue?vue&type=script&lang=js"
export * from "./FirstLoginModal.vue?vue&type=script&lang=js"

import "./FirstLoginModal.vue?vue&type=style&index=0&id=6b5fec9c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__